import InputMask from 'react-input-mask';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface TextFieldProps {
    name: string;
    id: string;
    path: string;
    label: string;
    value: string;
    placeholder: string;
    hasError: boolean;
    messageError: string;
    background: string;
    onChange: (arg0: any) => void;
}

export default function TextFieldsPhone(props: TextFieldProps): JSX.Element {
    const { name, id, path, label, value, placeholder, hasError, messageError, background, onChange } = props;
    return (
        <label className="relative text-gray-400 focus-within:text-gray-600 block  pt-2 mt-4 ">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`pointer-events-none w-8 h-8 absolute  top-1/2 transform  ${
                    hasError ? ' -translate-y-3/4 ' : ' -translate-y-1/2 '
                }  pb-1 right-3`}
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path d={path} />
            </svg>
            <label
                htmlFor={name}
                className={`${
                    background === 'dark' ? 'text-white' : 'text-sm-blue-primary'
                } font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5  text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm`}
            >
                {label}
            </label>
            {/* <InputMask mask="+56 9 9999 9999" maskChar={null} value={value} onChange={onChange} />*/}
            <InputMask mask="+56 9 9999 9999" value={value} placeholder={placeholder} onChange={onChange}>
                {(inputProps) => (
                    <input
                        {...inputProps}
                        name={name}
                        id={id}
                        type="text"
                        className={`form-input p-4 border-2 rounded-xl  shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none ${
                            hasError ? 'ring-2 ring-red-300 border-red-300 ' : 'border-gray-300'
                        }`}
                    />
                )}
            </InputMask>
            {hasError && <p className="text-sm text-red-300">{messageError}</p>}
        </label>
    );
}
